module.exports = __webpack_public_path__ + "img/police-fire.2b5f3212.png";